import React, { Component, Fragment } from "react";
import { CSSTransition } from "react-transition-group";
// import Nav from "./components/nav";
import Grid from "./components/grid";
import ImagePopUp from "./components/imagePopup.js";
import Footer from "./components/footer";
import Search from "./components/search";
import NotFound from "./components/notFoundEmpty";
import { InputEffect, url } from "./utils";
import "./stylesheets/app.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: Boolean,
      index: 0,
      items: [],
      querySearched: "",
      showPopUp: false,
      popUpImage: null,
      queryText: {
        notFound: false,
        emptyQuery: false
      }
    };
    this.handleImageClick = this.handleImageClick.bind(this);
    this.popUpHide = this.popUpHide.bind(this);
  }

  resetUrl() {
    // Wait for DOM ready
    requestAnimationFrame(() => {
      const searchValue = document.getElementById("searchInput").value;
      if (!searchValue) {
        return window.history.pushState({}, document.title, "/");
      }
    });
  }

  handleUrlSearch() {
    // On ComponentDidMount populate input with qury search
    const querySearch = new URLSearchParams(window.location.search).get("text");
    if (querySearch) {
      document.getElementById("searchInput").value = querySearch;
      this.searchImages(querySearch);
    }
  }

  searchImages(tag) {
    this.setState({
      isLoaded: false,
      query: tag
    });
    this.props.history.push(this.props.match.url + `?text=${tag}`);

    fetch(
      // Fetch url from .utils.js
      url.BASE_URL + `&tags=${tag}`
    )
      .then(res => res.json())
      .then(
        result => {
          this.setState({
            isLoaded: true,
            items: result.photos.photo,
            queryText: false
          });
          if (result.photos.photo.length === 0) { // Set state to not found and show related div
            this.setState({
              queryText: {
                notFound: true
              }
            });
          }
        },
        error => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
      .catch(err => {
        console.log("Error ", err);
      });
  }
  componentDidMount() {
    this.setState({
      isLoaded: true
    });
    InputEffect(); // init function
    this.handleUrlSearch();
  }

  
  parseImages = query => { // function arrow test
    let updateList = this.state.items;
    if (updateList !== undefined && query !== "") {
      this.searchImages(query);
    } else {
      this.setState({
        items: [],
        queryText: {
          emptyQuery: true
        }
      });
    }
  };

  // Handle button search
  clickSearchBtn() {
    let query = document.getElementById("searchInput").value.toLowerCase();
    this.parseImages(query);
  }

  // Handle search when user press "enter" key
  keyEnter(e) {
    if (e.keyCode === 13 || e.charCode === 13) {
      let query = e.target.value.toLowerCase();
      this.parseImages(query);
    }
  }

  // Get clicked item 
  handleImageClick(idx) {
    this.setState({ popUpImage: this.state.items[idx] });
  }

  popUpHide() {
    this.setState({ popUpImage: null });
  }

  content() {
    const isIE = /*@cc_on /^10/.test(@_jscript_version) @*/ false || !!document.documentMode;
    const stateItems = this.state.items;  // Assign array to child component's props
    if (isIE) { // Content to show if browser is <= IE 10
      return (
        <div>
          the content cannot be renedered, please use another browser or a newer
          version of Intenet explorer
        </div>
      );
    } else {
      return (
        <Fragment>
          <CSSTransition
            in={!this.state.isLoaded}
            timeout={350}
            classNames="display"
            unmountOnExit
            appear
          >
            <div className="content-overlay">
              <div className="loader-overlay"></div>
            </div>
          </CSSTransition>
          {/*<Nav />*/}
          <div className="container">
            <div id="flow">
              <span className="flow-1"></span>
              <span className="flow-2"></span>
              <span className="flow-3"></span>
            </div>
            <div className="section">
              <Search
                keyenter={this.keyEnter.bind(this)}
                clickbtn={this.clickSearchBtn.bind(this)}
              />
              {stateItems.length > 0 && (
                <Grid
                  images={stateItems}
                  onImageClick={this.handleImageClick}
                />
              )}

              <NotFound
                notFoundus={this.state.queryText.notFound}
                emptyValue={(this.resetUrl(), this.state.queryText.emptyQuery)}
                standard={this.state.items.length === 0}
              />
            </div>
          </div>
          <Footer />
          {this.state.popUpImage && (
            <ImagePopUp
              image={this.state.popUpImage}
              hideImage={this.popUpHide}
            />
          )}
        </Fragment>
      );
    }
  }

  render() {
    return this.content();
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/app.js